            <!-- Content Wrapper Start -->
            <div class="fm-content-wrapper">
                <div class="container-fluid">
                    <!-- Filter Section Start --> 
                    <div class="row">
                        <div class="col-12">
                            <div class="row align-items-center">
                                <div class="col-sm">
                                    <!-- Page Title -->
                                    <div class="fm-page-title">
                                        <h2 class="fm-head-24 fm-title mb-2">Storybooks</h2>
                                        <p class="mb-0">Create beautiful books from your life stories to share and treasure</p>
                                    </div>
                                </div>
                                <div class="col-auto mb-4 mb-sm-0">
                                    <a href="create-storybook.html" routerLink="create" class="fm-common-btn">
                                        <img src="images/icons/fm-plus-large.svg" class="fm-svg" alt="Plus Icon" />
                                        Create Storybook
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Filter Section End -->  

                    @if (!isInitializing()) {
                        @if (hasError()) {
                            <div class="fm-stories-empty-state">
                                <div class="fm-white-column text-center mt-4">
                                    <h4 class="fm-head-24 fm-head-sty2">Something went wrong</h4>
                                    <p class="mb-3">We couldn't load your storybooks. Please check your connection and try again.</p>
                                </div>
                            </div>
                        } @else if (storybooks().length === 0) {
                            <div class="fm-stories-empty-state">
                                <div class="fm-white-column text-center mt-4">
                                    <h4 class="fm-head-24 fm-head-sty2">No storybooks found</h4>
                                    <p class="mb-3">You haven't created any storybooks yet. Start creating one!</p>
                                </div>
                            </div>
                        } @else {
                            <!-- Story Book Section Start -->
                            <div class="row g-3 mt-3">
                                @for (storybook of storybooks(); track storybook.storybookId) {
                                    <div class="col-sm-6 col-lg-4 col-xxl-3">
                                        <div class="fm-stories-blog fm-match-height h-100">
                                            <div class="fm-stories-cover">
                                                <img class="fm-image" [src]="storybook.coverImageUrl || 'images/storybooks/bookcover-placeholder.png'" [alt]="storybook.title" onerror="this.src='images/storybooks/bookcover-placeholder.png'">
                                            </div>
                                            <div class="fm-stories-content">
                                                <div class="d-flex align-items-start justify-content-between mb-2">
                                                    <h4
                                                        class="fm-head-20 fm-head-sty2 mb-0 pe-2 fm-storybook-title"
                                                        [appTooltip]="storybook.title"
                                                    >
                                                        {{ storybook.title }}
                                                    </h4>
                                                    <div class="fm-question-actions fm-dropdown flex-shrink-0">
                                                        <button type="button" class="fm-question-menu-btn border-0 bg-transparent p-0" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Open storybook actions">
                                                            <img src="images/icons/fm-vertical-dots.svg" class="fm-svg" alt="Actions" />
                                                        </button>
                                                        <div class="dropdown-menu fm-dropdown-menu">
                                                            <a [routerLink]="['/app/storybooks/edit', storybook.storybookId]" class="dropdown-item fm-dropdown-item">
                                                                <img src="images/icons/fm-edit-pen.svg" class="fm-svg" alt="Edit" />
                                                                <span class="fm-question-action-label">Edit</span>
                                                            </a>
                                                            <button 
                                                                type="button" 
                                                                class="dropdown-item fm-dropdown-item"
                                                                (click)="confirmDeleteStorybook(storybook)">
                                                                <img src="images/icons/fm-delete-bl.svg" class="fm-svg" alt="Delete" />
                                                                <span class="fm-question-action-label">Delete</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p class="fm-storybook-description" [appTooltip]="storybook.description">{{ storybook.description }}</p>
                                                <div class="fm-user-profile">
                                                    <hr class="my-0" />
                                                    <div class="fm-card-btm">
                                                        <p class="fm-icon-content">
                                                        <img src="images/icons/fm-calendar-green.svg" class="fm-family-icon" alt="Calendar Icon" />
                                                        {{ storybook.memoryDate | date:'MMMM dd, yyyy' }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>

                            <!-- Infinite-scroll: load-more spinner -->
                            @if (isLoadingMore()) {
                                <div class="fm-load-more-spinner text-center py-4">
                                    <div class="spinner-border" role="status" style="width:1.75rem;height:1.75rem;border-width:3px;">
                                        <span class="visually-hidden">Loading more storybooks…</span>
                                    </div>
                                </div>
                            }

                            <!-- Sentinel -->
                            @if (hasMoreStorybooks()) {
                                <div id="storybooksScrollSentinel" class="fm-scroll-sentinel"></div>
                            }
                            <!-- Story Book Section End --> 
                        }
                    } @else {
                        <div class="fm-load-more-spinner text-center py-4 mt-4">
                            <div class="spinner-border" role="status" style="width:1.75rem;height:1.75rem;border-width:3px;">
                                <span class="visually-hidden">Loading storybooks…</span>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <!-- Content Wrapper End -->

            <!-- ── Delete Confirmation Modal (mirrors loved-ones.html pattern) ── -->
            @if (storybookToDelete()) {
                <app-delete-confirmation
                    title="Delete Storybook"
                    message="Are you sure you want to delete this storybook?"
                    confirmButtonText="Delete"
                    cancelButtonText="Cancel"
                    (confirmed)="deleteStorybook()"
                    (cancelled)="cancelDelete()"
                />
            }